import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router'
import isempty from 'lodash.isempty'
import { withStyles, AppBar, Toolbar, Typography, Button, IconButton, Hidden, Drawer, List, Grid, CircularProgress } from '@material-ui/core'

import { Menu, Search } from '@material-ui/icons'

import profileImg from '../../images/svg/profile.svg'
import logoImg from '../../images/svg/logo-2.svg'
import backToTop from '../../images/svg/back-to-top.svg'
import alert_bell from '../../images/svg/alert_bell.svg'
import close_white from '../../images/svg/close_white.svg'

import SearchBox from '../SearchBox'
import * as actions from '../../actions'
import queryString from 'query-string'
import * as utils from '../../utils'
import { isUserLogged, firstTimeFreeUser } from 'utils'
import { ROUTES_PATH, MESSAGE } from '../../constants'
import { fetchNotifications, markNotificationRead } from 'services/api'

import { Modal, ModalCloseButton, ModalContent, ModalDialog } from '@smooth-ui/core-em'
import { Box, Space } from 'UILibrary'
import { SignInContainer } from 'features/authentication/containers'
import { InvestorMenu } from 'features/investorDashboard/components'
import ButtonCustom from 'components/ButtonMaterial'
import bellIcon from 'images/bell-icon.svg'

const styles = theme => ({
  root: { flexGrow: 1 },
  flex: {
    flexGrow: 1,
    width: 'auto',
  },
  container: { display: 'flex' },
  menuButton: {
    marginLeft: '0',
    marginRight: '0',
    width: '48px',
    height: '48px',
    backgroundColor: '#00bcb5',
    borderRadius: '0',
    color: '#ffffff',
    order: 2,
    '&:hover': { backgroundColor: '#00bcb5' },
    '&:focus': { backgroundColor: '#00bcb5' },
  },
  headWrapper: {
    position: 'fixed',
    boxShadow: '0 3px 15px 0 rgba(0, 0, 0, 0.11)',
  },
  logoSpan: {
    display: 'flex',
    '& > img': {
      width: '187px',
      [theme.breakpoints.down('961')]: { height: '28px', width: 'auto' },
      [theme.breakpoints.down('600')]: { height: 'auto' },
    },
  },
  navbar: {
    backgroundColor: '#ffffff',
    color: '#000000',
    height: '64px',
    margin: '0',
    paddingLeft: '14px',
    paddingRight: '0',
    [theme.breakpoints.down('sm')]: {
      height: '48px',
      minHeight: '48px',
      paddingLeft: '10px',
    },
  },
  menubarRoot: {
    marginBottom: '64px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '48px',
    },
  },
  menuItem: {
    fontFamily: '"Rubik","Helvetica Neue",Arial,sans-serif',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '1.43',
    color: '#333645',
    textTransform: 'uppercase',
    padding: '22px',
    textDecoration: 'none',

    [theme.breakpoints.down('md')]: {
      padding: '22px 15px',
    },

    [theme.breakpoints.down('xs')]: {
      padding: '18px 15px 15px 0',
      color: '#888888',
    },
  },
  signInSignUpWrapper: {
    display: 'flex',
    width: '100%',
    height: '100%',
    justifyContent: 'space-around',
    backgroundColor: '#00bcb5',
  },
  verticalLine: {
    width: '1px',
    backgroundColor: '#ffffff96',
    margin: 'auto',
    height: '29px',
  },
  signIn: {
    color: '#fff',
    backgroundColor: '#00bcb5',
    height: '100%',
    width: '50%',
    fontSize: '16px',
    fontWeight: 'normal',
    padding: '0 12px 0 0',
    borderRadius: '0',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: { marginLeft: '0' },
    '&:focus': { backgroundColor: '#00bcb5' },
    '&:hover': { backgroundColor: '#00bcb5' },
  },
  signInButton: {
    color: '#fff',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '1.11',
    padding: '13px 8px',
    minHeight: '64px',
    [theme.breakpoints.down('sm')]: {
      fontWeight: '500',
      minHeight: 'inherit',
      padding: '6px 8px',
    },
  },
  signInseprator: {
    [theme.breakpoints.down('sm')]: {
      margin: '3px 0 0',
    },
  },
  profileImage: { margin: '0 15px', width: '37px' },
  listItem: {
    position: 'relative',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '3',
    color: '#333645',
    padding: '0 18px',
    textTransform: 'uppercase',
    '&active': { color: '#00bcb5' },
    '&:first-child': { padding: '0' },
  },
  listSignIn: {
    width: '100%',
    height: '48px',
    display: 'flex',
    justifyContent: 'left',
    padding: '0 0 0 18px',
    margin: '0',
  },
  profileSubMenu: {
    height: '64px',
    position: 'relative',
    width: '284px',
    order: 2,
    '& ul': {
      boxShadow: '0 2px 12px 2px rgba(0, 0, 0, 0.09)',
      borderRadius: '4px',
      border: '1px solid #ececec',
    },
    '& $menuItem': {
      padding: '8px 25px',
      fontSize: '16px',
      fontWeight: '100',
      lineHeight: '1.5',
      color: '#000000',
      display: 'block',
      maxWidth: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textTransform: 'capitalize',
      '&:last-child': { color: '#838383' },
    },
  },
  profileImageWrapper: {
    display: 'flex',
    background: '#fdd201',
    borderRadius: '50%',
    border: '1px solid #fdd201',
    width: '30px',
    height: '30px',
    overflow: 'hidden',
    marginRight: '15px',
  },
  logoWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  menuListToggle: {
    width: '90%',
    position: 'absolute',
    top: '106%',
    right: '6px',
  },
  menuDivider: { margin: '8px 0' },
  toggleDrawerButton: { outline: 'none' },
  mobileSlideClose: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    zIndex: '1',
    height: '28px',
    cursor: 'pointer',
  },
  slideCloseIcon: {
    width: '28px',
    height: '28px',
  },
  menuItemBellIcon: {
    position: 'relative',
    padding: '0',
    margin: '0 10px',
    display: 'none',
    '& span': {
      position: 'absolute',
      top: '-2px',
      right: '-5px',
      color: '#ffffff',
      backgroundColor: 'red',
      padding: '2px',
      borderRadius: '50%',
      fontSize: '10px',
    },
  },
  alertBellIcon: {
    width: '28px',
    height: '28px',
  },
  backToTopButton: {
    display: 'block',
    position: 'fixed',
    bottom: '20px',
    right: '30px',
    zIndex: '99',
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    padding: '0px',
    width: '28px',
    height: '28px',
  },
  backToTopIcon: {
    width: '28px',
    height: '28px',
  },
  searchBoxToggle: {
    marginRight: '20px',
    cursor: 'pointer',
  },
  progress: {
    color: '#00bcb5',
  },
  signupModal: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalPopupContainer: {
    height: '0%',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      '-webkit-overflow-scrolling': 'touch',
      paddingTop: '0',
      minHeight: 'inherit !important',
      marginTop: '5rem !important',
      marginBottom: '3rem !important',
    },
    [theme.breakpoints.down('xs')]: {
      '& .sui-modal-content': {
        padding: '20px 20px 20px 20px !important',
      },
      '& .sui-modal-close-button': {
        right: '7px !important',
      },
      '& .sui-input': {
        display: 'flex',
        '& a': {
          width: '80px',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'center',
        },
      },
      '& .sui-typo': {
        fontSize: '14px',
        display: 'inline-block',
      },
      '& .sui-box': {
        '& div > img': {
          width: '100%',
        },
      },
    },
  },
  mobileLogo: {
    height: '25px',
  },
  notifyBellMenu: {
    order: '1',
    marginRight: '16px',
    marginLeft: '16px',
    cursor: 'pointer',
    width: '20px',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0',
      marginRight: '20px',
    },
  },
  circleIcon: {
    width: '12px',
    height: '12px',
    borderRadius: '100%',
    border: 'solid 2px #fff',
    backgroundColor: '#eb3d3d',
    flex: 'none',
    position: 'absolute',
    right: '-3px',
    top: '0',
  },
})

class MenuBar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menuOpen: false,
      drawerOpen: false,
      showMoveToTop: false,
      showSearchBox: false,
      signInModalOpened: false,
      openSavedSearch: false,
      loginStatus: isUserLogged(this.props.user) ? true : false,
      notifications: [],
      notificationSelected: false,
      unreadNotifications: [],
    }
    this.timeoutId = null
  }

  wheelFunction = () => {
    this.timeoutId && clearTimeout(this.timeoutId)
  }

  componentDidUpdate(prevProps) {
    const { actions, showSignIn } = this.props
    if (utils.getToken()) {
      actions.userStatusUpdate(true)
    } else {
      actions.userStatusUpdate(false)
    }

    if (utils.isUserLogged(this.props.user) !== utils.isUserLogged(prevProps.user)) {
      this.settingNotification()
      utils.isUserLogged(this.props.user) && this.fetchNotification()
    }
    if (showSignIn && !this.state.signInModalOpened) {
      this.setState(prevState => ({ signInModalOpened: !prevState.signInModalOpened }))
    }
  }

  markNotificationUnread = () => {
    this.setState({
      unreadNotifications: [],
    })
  }

  ///  AUTHFLOW INTEGRATION
  toogleSignInModalVisibilty = () => {
    this.setState(prevState => ({ signInModalOpened: !prevState.signInModalOpened }))
    this.props.actions.showSignInModal(false)
  }

  handleAuthenticationSuccess = () => {
    this.toogleSignInModalVisibilty()
    this.props.actions.showFlashMessage(null, "You've been logged in!")
    firstTimeFreeUser(this.props.user) && !this.props.hidePremium && this.props.history.push(ROUTES_PATH.WELCOME)
  }

  handleSocialAuthNotCompleted = () => {
    this.props.history.push({ pathname: '/auth/register' })
  }

  handleClickSignUpBtn = () => {
    this.props.history.push({ pathname: '/auth/register', search: '?expanded=true' })
  }
  handleClickSignUpBtnMobile = () => {
    this.handleToggleDrawer(false)()
    this.props.history.push({ pathname: '/auth/register', search: '?expanded=true' })
  }

  handleAuthenticationFailed = response => {
    this.props.actions.showFlashMessage('error', 'Incorrect Credentials')
  }

  handleNonExpectedErrors = err => {
    this.toogleSignInModalVisibilty()
    this.props.actions.showFlashMessageOnUnexpectedError(err, MESSAGE.CONTACT_ADMIN)
  }

  //TODO: IMPLEMENT
  logout = () => {
    this.setState({
      notificationSelected: false,
    })
    this.props.actions.signOut()
    this.forceUpdate()
  }

  componentWillMount() {
    if (queryString.parse(this.props.location.search).token) {
      utils.trackEvent({ category: 'Register', action: 'Website Registration' })
      this.props.actions.showFlashMessage(null, 'Your account has been activated, please log in')

      this.setState({ signInModalOpened: true })
    }
    if (queryString.parse(this.props.location.search).signin) {
      this.setState({ signInModalOpened: true })
    }
    if (queryString.parse(this.props.location.search).logged) {
      this.props.actions.showFlashMessage(null, "You've been logged in!")
      this.props.history.push({ search: '' })
    }
  }

  componentDidMount() {
    const query = queryString.parse(this.props.location.search)
    if (query.address) {
      this.props.actions.fetchLocation(query.address)
    }
    this.settingNotification()
    utils.isUserLogged(this.props.user) && this.fetchNotification()

    window.addEventListener('scroll', this.scrollFunction, false)
    window.addEventListener('wheel', this.wheelFunction, false)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollFunction, false)
    window.removeEventListener('wheel', this.wheelFunction, false)
  }

  fetchNotification() {
    fetchNotifications(this.props.user.token).then(response => {
      if (!isempty(response.notifications)) {
        let a = response.notifications
          .filter(obj => obj.property)
          .sort(function(x, y) {
            return new Date(y.displayAt) - new Date(x.displayAt)
          })
          .map(obj => (obj.message = JSON.parse(obj.message)))
        console.log(a)
        this.setState({
          notifications: response.notifications
            .filter(obj => obj.property)
            .sort(function(x, y) {
              return new Date(y.displayAt) - new Date(x.displayAt)
            }),
          unreadNotifications: response.notifications.filter(obj => !obj.isRead),
        })
      }
    })
  }

  settingNotification() {
    if (this.props.location !== undefined && this.props.location.pathname.indexOf('settings') > -1) {
      this.setState({ drawerOpen: true })
    }
  }

  handleToggleMenu = () => {
    this.setState(state => ({ menuOpen: !state.menuOpen }))
  }

  handleCloseMenu = event => {
    if (this.anchorEl.contains(event.target)) {
      return
    }

    this.setState({ menuOpen: false })
  }

  toggleSearchBox = () => {
    const { showSearchBox } = this.state

    this.setState({
      showSearchBox: !showSearchBox,
    })
  }

  handleToggleDrawer = bool => () => {
    !bool && this.state.notificationSelected && this.markReadNotification()
    this.setState({ drawerOpen: bool, notificationSelected: false })
  }

  // When the user scrolls down 400px from the top of the document, show the button
  scrollFunction = () => {
    this.setState({
      showMoveToTop: document.body.scrollTop > 400 || document.documentElement.scrollTop > 400,
    })
  }

  // When the user clicks on the button, scroll to the top of the document
  moveToTop = () => {
    var doc = document.documentElement
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)

    if (top > 0) {
      window.scrollTo(0, top - 50)
      this.timeoutId = setTimeout(this.moveToTop, 10)
    }
  }

  handleClickSignInBtn = () => {
    const subdomain = ((this.props.subdomain && this.props.subdomain.record_type) || '').toLowerCase()
    if (subdomain === 'franchisee' || subdomain === 'adcouncil') {
      this.handleToggleMenu()
    } else {
      this.toogleSignInModalVisibilty()
    }
  }

  handleClickSignInBtnMobile = () => {
    this.handleToggleDrawer(false)()
    this.handleClickSignInBtn()
  }

  getHVALogo(classes) {
    const logo = (
      <React.Fragment>
        <Hidden xsDown>
          <img src={logoImg} height="42px" alt={'logo'} />
        </Hidden>
        <Hidden smUp>
          <div className={classes.mobileLogo}>
            <img src={logoImg} height="25px" alt={'logo'} />
          </div>
        </Hidden>
      </React.Fragment>
    )

    return (
      <Grid item className={classes.logoWrapper}>
        {/* The home link will be build using a html link if we are under a subdomain, since we want to redirect to home main/base domain, if not we build it using react-router link to no reload the app } */}
        {!utils.isBaseDomain(window.location.hostname) ? (
          //FIXME we can extract this logic to create url somewhere
          <a
            href={`${window.location.protocol}//${process.env.REACT_APP_BASE_DOMAINS}${window.location.port ? ':' + window.location.port : ''}`}
            className={classes.logoSpan}
            id={'hva_logo'}>
            {logo}
          </a>
        ) : (
          <Link to="/" className={classes.logoSpan} id={'hva_logo'}>
            {logo}
          </Link>
        )}
      </Grid>
    )
  }

  getSearchBox(classes, isSearchBox) {
    return (
      <Grid item className={classes.headerSearchBox}>
        {isSearchBox ? (
          <Hidden xsDown>
            <SearchBox inMenu />
          </Hidden>
        ) : null}
      </Grid>
    )
  }

  markReadNotification() {
    markNotificationRead(this.props.user.token).then(response => {
      if (isempty(response.errors)) {
        this.markNotificationUnread()
      }
    })
  }

  investorMenuClosed = () => {
    this.state.notificationSelected && this.markReadNotification()
    this.setState({
      openSavedSearch: false,
      notificationSelected: false,
    })
  }

  openSavedSearches = () => {
    this.setState({
      openSavedSearch: true,
    })
  }

  getUserMenu(classes) {
    const loggedIn = utils.isUserLogged(this.props.user)
    return !loggedIn ? (
      !this.props.user.isLoadingUserInfo ? (
        <div className={classes.signInSignUpWrapper}>
          <img src={profileImg} alt={''} className={classes.profileImage} />
          <Button
            className={classes.signIn}
            id={'sign_in_btn'}
            buttonRef={node => {
              this.anchorEl = node
            }}
            aria-owns={this.state.menuOpen ? 'menu-list-grow' : null}
            aria-haspopup="true"
            onClick={this.handleClickSignInBtn}>
            Sign in{' '}
          </Button>
          <span className={classes.verticalLine} />
          <Button
            className={classes.signIn}
            id={'sign_in_btn'}
            buttonRef={node => {
              this.anchorEl = node
            }}
            aria-owns={this.state.menuOpen ? 'menu-list-grow' : null}
            aria-haspopup="true"
            onClick={this.handleClickSignUpBtn}>
            Sign up{' '}
          </Button>
        </div>
      ) : (
        <CircularProgress className={classes.progress} />
      )
    ) : (
      <InvestorMenu
        hidePremium={this.props.hidePremium}
        setShowSettings={this.props.setShowSettings}
        showSettings={this.props.showSettings}
        user={this.props.user}
        onLogOut={this.logout}
        onCloseMenu={this.investorMenuClosed}
        openSavedSearch={this.state.openSavedSearch}
        notificationSelected={this.state.notificationSelected}
        notifications={this.state.notifications}
        markNotificationUnread={this.markNotificationUnread}
      />
    )
  }

  getUserMenuMobile(classes) {
    const loggedIn = utils.isUserLogged(this.props.user)
    return (
      <div>
        {!loggedIn ? (
          <List className={classes.listItem}>
            <span className={classes.mobileSlideClose} onClick={this.handleToggleDrawer(false)}>
              <img src={close_white} alt={'close'} className={classes.slideCloseIcon} />
            </span>
            <div className={classes.signInSignUpWrapper}>
              <img src={profileImg} alt={''} className={classes.profileImage} />
              <Button
                className={`${classes.signIn} ${classes.listSignIn}`}
                id={'sign_in_btn'}
                buttonRef={node => {
                  this.anchorEl = node
                }}
                aria-owns={this.state.menuOpen ? 'menu-list-grow' : null}
                aria-haspopup="true"
                onClick={this.handleClickSignInBtnMobile}>
                Sign in{' '}
              </Button>
              <span className={classes.verticalLine} />
              <Button
                className={`${classes.signIn} ${classes.listSignIn}`}
                id={'sign_in_btn'}
                buttonRef={node => {
                  this.anchorEl = node
                }}
                aria-owns={this.state.menuOpen ? 'menu-list-grow' : null}
                aria-haspopup="true"
                onClick={this.handleClickSignUpBtnMobile}>
                Sign up{' '}
              </Button>
            </div>
          </List>
        ) : (
          <InvestorMenu
            hidePremium={this.props.hidePremium}
            setShowSettings={this.props.setShowSettings}
            showSettings={this.props.showSettings}
            user={this.props.user}
            onLogOut={this.logout}
            onCloseMenu={this.handleToggleDrawer(false)}
            notificationSelected={this.state.notificationSelected}
            notifications={this.state.notifications}
            markNotificationUnread={this.markNotificationUnread}
          />
        )}
      </div>
    )
  }

  showNotifications = () => {
    this.setState({
      notificationSelected: !this.state.notificationSelected,
      drawerOpen: !this.state.drawerOpen,
    })
  }

  render() {
    // FIX: Removing Anonymous function that causes event trigger even after unmount. Fixed this in componentDidmount and componentWillUnMount

    const { classes, withSearchBox, user } = this.props

    return (
      <div className={`${classes.root} ${classes.menubarRoot}`}>
        <AppBar position="static" className={classes.headWrapper}>
          <Toolbar className={classes.navbar}>
            <Grid container className={classes.flex}>
              {this.getHVALogo(classes)}

              {this.getSearchBox(classes, withSearchBox)}
            </Grid>
            <Hidden smDown>
              <Typography className={classes.menuItem} style={{ display: 'none' }}>
                Make Offer
              </Typography>
              {isUserLogged(user) && (
                <ButtonCustom link className={classes.menuItem} onClick={this.openSavedSearches}>
                  Saved
                </ButtonCustom>
              )}
              <Typography className={`${classes.menuItem} ${classes.menuItemBellIcon}`}>
                <span>02</span>
                <img src={alert_bell} alt={'alert_bell'} className={classes.alertBellIcon} />
              </Typography>
              <div className={classes.profileSubMenu} style={isUserLogged(user) ? { width: '220px' } : {}}>
                {this.getUserMenu(classes)}
              </div>
            </Hidden>
            <Hidden mdUp>
              {withSearchBox &&
                (this.state.showSearchBox ? (
                  <SearchBox isSearchAsHeader toggleSearchBox={this.toggleSearchBox} />
                ) : (
                  <Hidden smUp>
                    <Search className={classes.searchBoxToggle} onClick={this.toggleSearchBox} />
                  </Hidden>
                ))}
              {user.isLoadingUserInfo ? null : (
                <IconButton className={classes.menuButton} color="inherit" aria-label="Menu" onClick={this.handleToggleDrawer(true)}>
                  <Menu />
                </IconButton>
              )}
              <Drawer anchor="top" open={this.state.drawerOpen} onClose={this.handleToggleDrawer(false)}>
                <div role="button" className={classes.toggleDrawerButton}>
                  {this.getUserMenuMobile(classes)}
                </div>
              </Drawer>
            </Hidden>
            {isUserLogged(user) && (
              <div className={classes.notifyBellMenu} onClick={() => this.showNotifications()}>
                <a>
                  <img alt="Notifications" title="Notifications" src={bellIcon} />
                  {this.state.unreadNotifications.length > 0 && <span className={classes.circleIcon} />}
                </a>
              </div>
            )}
          </Toolbar>
        </AppBar>

        <Modal opened={this.state.signInModalOpened && !isUserLogged(user)} onClose={this.toogleSignInModalVisibilty} className={classes.signupModal}>
          <ModalDialog width={{ sm: 1, md: '410px' }} className={classes.modalPopupContainer}>
            <ModalContent py="22" px="30">
              <Box display="flex" flexDirection="row">
                <Box>
                  <ModalCloseButton top="15px" right="30px" />
                </Box>
                <Box>
                  <Typography variant="title" gutterBottom>
                    Sign In
                  </Typography>
                </Box>
              </Box>
              <Space size="xl" />
              <SignInContainer
                onAuthenticationSuccess={this.handleAuthenticationSuccess}
                onSocialAuthNotCompleted={this.handleSocialAuthNotCompleted}
                onAuthenticationFailed={this.handleAuthenticationFailed}
                onNonExpectedErrors={this.handleNonExpectedErrors}
              />
            </ModalContent>
          </ModalDialog>
        </Modal>

        {this.state.showMoveToTop ? (
          <button onClick={() => this.moveToTop()} title="Go to top" className={classes.backToTopButton}>
            <img src={backToTop} alt={'back-to-top'} className={classes.backToTopIcon} />
          </button>
        ) : null}
      </div>
    )
  }
}

MenuBar.propTypes = {
  classes: PropTypes.object.isRequired,
  withSearchBox: PropTypes.bool,
}

function mapStateToProps(state) {
  return {
    user: state.user,
    showSignIn: state.common.showSignIn,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

const menuBar = connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuBar)
export default withStyles(styles)(withRouter(menuBar))



// WEBPACK FOOTER //
// ./src/components/header/MenuBar.js